import {
  GRIN_SCOPE_TYPE_LG,
  GRIN_SCOPE_TYPE_LG_MINI,
  GRIN_SCOPE_TYPE_MINI,
  GRIN_SCOPE_TYPE_REGULAR
} from 'consts/billingConsts'
import images from 'resources'

export const getScopeProductsContent = t => ({
  [GRIN_SCOPE_TYPE_REGULAR]: {
    type: GRIN_SCOPE_TYPE_REGULAR,
    name: t('dialogs.orderScopes.grinScope'),
    selectorDescription: t('dialogs.orderScopes.grinScopeSelectorDescription'),
    comparisonSubTitle: t('dialogs.orderScopes.grinScopeDescription'),
    comparisonWidth: `71.1 ${t('dialogs.orderScopes.grinScopeWidthUnit')}`,
    comparisonDescription: t('dialogs.orderScopes.grinScopeDescription2'),
    image: images.grinScope,
    comparisonImage: images.grinScopeInfo,
    comparisonArrowImage: images.grinScopeWidthArrow,
    comparisonArrowImageMobile: images.grinScopeWidthArrowMobile
  },
  [GRIN_SCOPE_TYPE_MINI]: {
    type: GRIN_SCOPE_TYPE_MINI,
    name: t('dialogs.orderScopes.grinScopeMini'),
    selectorDescription: t('dialogs.orderScopes.grinScopeMiniSelectorDescription'),
    comparisonSubTitle: t('dialogs.orderScopes.grinScopeMiniDescription'),
    comparisonWidth: `60 ${t('dialogs.orderScopes.grinScopeWidthUnit')}`,
    comparisonDescription: t('dialogs.orderScopes.grinScopeMiniDescription2'),
    image: images.grinScopeMini,
    comparisonImage: images.grinScopeMiniInfo,
    comparisonArrowImage: images.grinScopeMiniWidthArrow,
    comparisonArrowImageMobile: images.grinScopeMiniWidthArrowMobile
  },
  [GRIN_SCOPE_TYPE_LG]: {
    type: GRIN_SCOPE_TYPE_LG,
    name: t('dialogs.orderScopes.grinScopeLG'),
    selectorDescription: t('dialogs.orderScopes.grinScopeLGDescription'),
    comparisonSubTitle: t('dialogs.orderScopes.grinScopeLGDescription'),
    comparisonWidth: '',
    comparisonDescription: t('dialogs.orderScopes.grinScopeLGDescription2'),
    image: images.grinScopeLG,
    comparisonImage: images.grinScopeLGInfo,
    productTooltip: t('dialogs.orderScopes.grinScopeLGProductTooltip')
  },
  [GRIN_SCOPE_TYPE_LG_MINI]: {
    type: GRIN_SCOPE_TYPE_LG_MINI,
    name: t('dialogs.orderScopes.grinScopeLGMini'),
    selectorDescription: t('dialogs.orderScopes.grinScopeLGMiniDescription'),
    comparisonSubTitle: t('dialogs.orderScopes.grinScopeLGMiniDescription'),
    comparisonWidth: '',
    comparisonDescription: t('dialogs.orderScopes.grinScopeLGMiniDescription2'),
    image: images.grinScopeLGMini,
    comparisonImage: images.grinScopeLGMiniInfo,
    productTooltip: t('dialogs.orderScopes.grinScopeLGMiniProductTooltip')
  }
})
